module.exports = __webpack_public_path__ + "img/addNote.31608bc6.png";